<div
  class="tag"
  [class]="{
    'green': !date,
    'blue': date,
  }"
>
  <span>{{ date | officerStatus }}</span>
</div>
